<template>
  <div style="margin-left: 10px; margin-right: 10px">
    <v-overlay v-if="loading"> Cargando Documento </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card>
          <v-card-title>{{ title }}</v-card-title>
          <v-btn
            @click="goRoute('/productos-inventarios/entradas')"
            text
            color="red"
          >
            <i style="color: red" class="lni lni-chevron-left"></i> Regresar a
            documentos
          </v-btn>
          <v-btn
            @click="
              verifySelectedOrigen(() => {
                formExistKey++;
                showModalExist = true;
                newLoadData = false;
              })
            "
            v-if="!Aplicado"
            text
            color="primary"
          >
            <i class="lni lni-plus"></i> Ingresar Producto
          </v-btn>

          <v-btn @click="guardar()" v-if="!Aplicado" text color="green">
            <i class="lni lni-save"></i> Guardar
          </v-btn>

          <v-btn
            @click="saveSend()"
            v-if="!Aplicado && this.$route.params.idDocumento"
            text
            color="green"
          >
            <i class="lni lni-save"></i> Guardar y Enviar a inventario
          </v-btn>

          <v-card-text>
            <v-row>
              <v-col md="4">
                <v-text-field
                  v-on:keyup.enter="searchProducts()"
                  v-model="code"
                  label="Escanea o escribe el codigo del producto"
                ></v-text-field>
              </v-col>
              <v-col md="2">
                <v-btn color="primary" @click="searchProducts"> Buscar </v-btn>
              </v-col>
              <v-col md="6">
                <v-autocomplete
                  :items="origenes"
                  item-value="id"
                  item-text="Nombre"
                  v-model="Origen"
                  label="Centro de consumo"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <h5>Facturas en este documento</h5>
            <template v-for="(fact, index) in facturasDoc">
              <v-chip :key="index" color="blue">
                {{ fact.Nombre }} - {{ fact.ProvNombre }}
              </v-chip>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <uv-data-table
          :config="config"
          :data="productsDocument"
          :pageRows="30"
          @buttonClick="dtButtonClick"
          @buttonOptClick="optButtonClick"
        ></uv-data-table>
      </v-col>
    </v-row>
    <modal
      v-model="showModal"
      :showFooter="false"
      title="Agregar Producto Nuevo"
    >
      <productoForm
        :facturasDocument="facturasDoc"
        :loadData="newLoadData"
        :key="formKey"
        @toggle="toggleModal"
        @successData="saveProduct"
      ></productoForm>
    </modal>
    <modal
      v-model="showModalExist"
      :showFooter="false"
      title="Agregar de producto existente"
    >
      <productoExistForm
        :Origen="Origen"
        :facturasDocument="facturasDoc"
        :loadData="newLoadData"
        :key="formExistKey"
        @toggle="showModalExist = false"
        @successData="saveExistProduct"
      ></productoExistForm>
    </modal>
    <modal
      v-model="showModalFactura"
      :showFooter="false"
      title="Agregar Numero de Factura"
    >
      <productoFacturaForm
        :facturasDocument="facturasDoc"
        :key="formFacturaKey"
        @toggle="showModalFactura = false"
        :ids="idsSelected"
        @successData="successFactura"
      ></productoFacturaForm>
    </modal>
  </div>
</template>

<style>
.menubtn {
  display: none;
}
</style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import productoForm from "../RecepcionMercancias/ProductAddForm.vue";
import productoExistForm from "../RecepcionMercancias/ProductExistForm.vue";
import productoFacturaForm from "../RecepcionMercancias/ProductNumeroFacturaForm.vue";

export default {
  name: "DocumentosCreator",
  components: {
    modal,
    uvDataTable,
    productoForm,
    productoExistForm,
    productoFacturaForm,
  },
  props: [],
  data() {
    return {
      MainDepartamento: "",
      appName: process.env.VUE_APP_NAME,
      Origen: "",
      loading: false,
      Aplicado: false,
      title: "Nuevo Documento de Recepción de inventarios",
      self: this,
      code: "",
      showModal: false,
      showModalExist: false,
      showModalFactura: false,
      formKey: 0,
      formExistKey: 0,
      newLoadData: false,
      formFacturaKey: 0,
      idsSelected: [],
      productsDocument: [],
      formIndex: 0,
      editMode: false,
      editData: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},

      config: {
        selectableRow: true,
        orderByCol: { Field: "Nombre", Type: "Asc" },
        selectConfig: {
          multiSelect: true,
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Modificar Num. Factura",
            icon: "lni lni-ticket-alt",
            buttonId: "modificarFactura",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentProduct",
            require: true,
            limitRequire: 1,
          },
        ],
        fields: [
          {
            value: "Nombre",
            text: "Nombre",
          },
          {
            value: "Cantidad",
            text: "Cantidad",
          },
          {
            value: "PreVenta",
            text: "Precio",
          },
          {
            value: "FacturaName",
            text: "Factura",
          },
        ],
      },
    };
  },
  methods: {
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database
        .ref("PDV/Inventario/Origenes")
        .once("value");
      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }

        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    dtButtonClick(buttonId, idSelected) {
      if (this.Aplicado) {
        this.$swal(
          "No puedes modificar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      if (buttonId == "modificarFactura") {
        this.formFacturaKey++;
        this.idsSelected = idSelected;
        this.showModalFactura = true;
      }
      if (buttonId == "deleteDocumentProduct") {
        this.deleteItem(idSelected);
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Categories, { id: code });
      if (itemIndex >= 0) {
        return this.Categories[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        alert("Creando");
        this.$pgsHelper.log(data);
      } else if (doAction == "EDIT") {
        alert("editando");
        this.$pgsHelper.log(data);
      }
    },
    saveProduct(datos) {
      this.$pgsHelper.log(datos);
      datos.Precio = parseFloat(datos.Precio);
      datos.Cantidad = parseInt(datos.Existencia);
      datos.Existencia = 0; //parseInt(datos.Existencia);
      datos.Alerta = parseInt(datos.Alerta);
      //datos.Departamentos = [datos.Departamento];
      datos.Tipo = "Producto";
      //datos.FechaCreacion     = new moment().format('YYYY-MM-DD')
      datos.Orden = parseInt(datos.Orden);
      //datos.Departamento      =  this.MainDepartamento;

      this.$pgsHelper.log(JSON.stringify(datos));

      this.$swal({
        title: "¿Deseas crear este nuevo producto?",
        text: "Se registrar el producto y se agregara una entrada de inventario en este documento",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar!",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          //'ProShop-Productos-crearProducto'
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-createProducto", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El producto se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.$swal({
                title: "Agregando entrada de inventario",
                text: "",
                icon: "",
                onBeforeOpen: () => {
                  this.$swal.showLoading();
                },
              });
              this.productsDocument.push({
                id: result.value.data.data.Id,
                Nombre: datos.Nombre,
                Factura: {
                  Id: datos.Factura,
                  Nombre: datos.facturaNombre,
                  ProvId: datos.provedorSearch,
                  ProvNombre: datos.proveedorNombre,
                },
                FacturaName: datos.facturaNombre,
                Cantidad: datos.Cantidad,
                PreVenta: datos.Precio,
                PreCompra: datos.precioCompra,
                MonVenta: datos.Moneda,
                MonCompra: datos.monedaCompra,
                Codigo: datos.Codigo,
              });

              this.$swal.close();
              this.$swal({
                title: "Entrada de producto almacenada correctamente",
                text: "Se registro una entrada de producto previo a inventario",
                icon: "success",
              }).then(() => {
                this.toggleModal(false);
                //this.getCategories();
              });
            });
          } else {
            this.$swal(
              "Error saving Producto",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    saveExistProduct(datos) {
      if (this.productsDocument.length > 450) {
        this.$swal(
          "No puedes agregar mas de 450 productos al documento",
          "",
          "error"
        );
        return false;
      }
      this.productsDocument.push({
        id: datos.producto,
        Nombre: datos.nombre,
        Factura: {
          Id: datos.factura,
          Nombre: datos.facturaNombre,
          ProvId: datos.provedorSearch,
          ProvNombre: datos.proveedorNombre,
        },
        FacturaName: datos.facturaNombre,
        Motivo: "",
        Cantidad: datos.cantidad,
        Notas: "",
        PreVenta: datos.newPrice,
        PreCompra: datos.precioCompra,
        MonVenta: datos.monedaVenta,
        MonCompra: datos.monedaCompra,
        Codigo: datos.codigo,
      });
      this.showModalExist = false;
    },
    successFactura(data) {
      data.idRow.forEach((element) => {
        this.productsDocument.forEach((prod) => {
          if (prod.id == element) {
            prod.Factura = {
              Id: data.n_factura,
              Nombre: data.facturaNombre,
              ProvId: data.provedorSearch,
              ProvNombre: data.proveedorNombre,
            };
            prod.FacturaName = data.facturaNombre;
          }
        });
      });

      this.showModalFactura = false;

      this.$swal({
        title: "Numero de factura modificado",
        text: "Los productos seleccionados cambiaron su numero de factura",
        icon: "success",
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    verifySelectedOrigen(callback) {
      if (this.Origen == "") {
        this.$swal("Seleccione un centro de consumo", "", "error");
        return false;
      }
      {
        callback();
      }

      return true;
    },
    async searchProducts() {
      if (this.Aplicado) {
        this.$swal(
          "No puedes modificar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      this.newLoadData = false;
      this.$swal({
        title: "Buscando Productos",
        text: "",
        icon: "",
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
      //this.code = "691316727252";
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_Productos", [
        firestore.where("CodigoBarras", "==", this.code),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let products = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      if (products.length > 0) {
        this.formExistKey++;
        this.newLoadData = { ProductoId: products[0].id };
        this.showModalExist = true;
      } else {
        this.formKey++;
        this.newLoadData = { CodigoBarras: this.code };
        this.showModal = true;
      }
      this.$swal.close();
    },
    async getProdDoc() {
      let simulatorData = [];

      this.productsDocument = simulatorData;
    },
    async getDocumentInfo(id) {
      this.loading = true;
      this.productos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("PDV_Prod_EntSal/", id);
      const data = await firestore.getDoc(doc);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = { id: data.ref.id, ...data.data() };

      this.Aplicado = document.Aplicado;
      let productos = Object.entries(document.Productos);
      this.Origen = document.Origen;
      productos.forEach((element) => {
        let datos = element[1];
        this.productsDocument.push({
          id: datos.Id,
          FacturaName: datos.Factura.Nombre,
          Nombre: datos.Nombre,
          Factura: datos.Factura,
          Motivo: "",
          Cantidad: datos.Cantidad,
          Notas: "",
          PreVenta: datos.PreVenta,
          PreCompra: datos.PreCompra,
          MonCompra: datos.MonCompra,
          MonVenta: datos.MonVenta,
          Moneda: datos.Moneda,
          Codigo: datos.codigo,
        });
      });
      this.loading = false;
    },
    guardar(sendInv = false) {
      if (this.Origen == "") {
        this.$swal(
          "Seleccione un centro de consumo",
          "Para continuar por favor indique el centro de consumo al que iran los productos",
          "error"
        );
        return false;
      }
      let data = {
        Productos: [],
        TipoMovimiento: "Entrada",
        FechaMovimiento: new moment().format("YYYY-MM-DD"),
        Origen: this.Origen,
      };
      this.productsDocument.forEach((element) => {
        data.Productos.push({
          Id: element.id,
          Nombre: element.Nombre,
          Factura: element.Factura,
          Cantidad: parseInt(element.Cantidad),
          PreVenta: parseFloat(element.PreVenta),
          PreCompra: parseFloat(element.PreCompra),
          MonCompra: element.MonCompra,
          MonVenta: element.MonVenta,
          Moneda: element.Moneda,
        });
      });
      this.$pgsHelper.log(data);
      if (this.$route.params.idDocumento) {
        this.editDocument(data, sendInv);
      } else {
        this.saveDocument(data, sendInv);
      }
    },
    saveSend() {
      this.guardar(true);
    },
    sendInventario() {
      let datos = {
        Id: this.$route.params.idDocumento,
        TipoMovimiento: "Entrada",
      };
      this.$swal({
        title: "¿Deseas afectar el inventario con los productos indicados?",
        text: " El documento sera enviado a inventario ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-aplicarPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_RECEPCION_APLICAR",
              Mensaje: `Entrada de inventario aplicada a stock: ${datos.id || datos.Folio || ""}`.trim(),
              reference: { id: datos.id, tp: "INV-RecepcionMercancia", al: datos.Folio || "RECEPCION INVENTARIO" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El documento se envio a inventario corretamente",
              icon: "success",
            });
            this.Aplicado = true;
          } else {
            this.$swal(
              "Error aplicando inventario",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteItem(id) {
      this.$swal({
        title: "¿Deseas eliminar este producto del documento?",
        text: "Los cambios se veran reflejados hasta realizar el guardado ",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.productsDocument.forEach((element, index) => {
            if (element.id == id) {
              this.productsDocument.splice(index, 1);
            }
          });
          this.$swal({
            title: "Eliminado",
            text: "El producto se elimino corretamente",
            icon: "success",
          });
        }
      });
    },
    saveDocument(datos, sendInv) {
      this.$swal({
        title:
          "¿Deseas crear este nuevo documento con los productos indicados?",
        text: "Se registrar el documento y sus productos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-crearPreInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            const targetId = result.value.data.data?.Id || result.value.data.id || datos.Id;
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_RECEPCION_CREATE",
              Mensaje: `Documento de recepción creado: ${datos.Folio || targetId || ""}`.trim(),
              reference: { id: targetId, tp: "INV-RecepcionMercancia", al: datos.Folio || "RECEPCION INVENTARIO" },
              data: datos
            });
            this.$swal({
              title: "Guardado",
              text: "El documento se guardo corretamente",
              icon: "success",
            });
            this.$router.push({
              path:
                "/productos-inventarios/documentoRecepcion/" +
                result.value.data.data.Id,
            });
            if (sendInv) {
              this.sendInventario();
            }
          } else {
            this.$swal(
              "Error saving Documento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editDocument(datos, sendInv) {
      this.$pgsHelper.log(datos);
      let editData = {
        Origen: this.Origen,
        Id: this.$route.params.idDocumento,
        Productos: [],
        TipoMovimiento: "Entrada",
      };
      let prod = [];
      datos.Productos.forEach((element) => {
        //prod[element.Id.toString()] =
        prod.push({
          Id: element.Id,
          Nombre: element.Nombre,
          Factura: element.Factura,
          Cantidad: parseInt(element.Cantidad),
          PreVenta: parseFloat(element.PreVenta),
          PreCompra: parseFloat(element.PreCompra),
          MonVenta: element.MonVenta,
          MonCompra: element.MonCompra,
        });
      });

      editData.Productos = prod;

      this.$swal({
        title: "¿Deseas modificar este documento con los productos indicados?",
        text: "Se modificara el documento y sus productos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Inventario-editarPreInventario", editData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.writeLog({
              Evento: "INVENTARIO_RECEPCION_EDIT",
              Mensaje: `Documento de recepción editado: ${editData.Id}`,
              reference: { id: editData.Id, tp: "INV-RecepcionMercancia", al: "RECEPCION INVENTARIO" },
              data: editData
            });
            this.$swal({
              title: "Guardado",
              text: "El documento se guardo corretamente",
              icon: "success",
            });
            //this.$router.push({path:'/productos-inventarios/documentoRecepcion/'+result.value.data.data.Id});
            if (sendInv) {
              this.sendInventario();
            }
          } else {
            this.$swal(
              "Error saving Documentos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
  },
  computed: {
    origenes() {
      let ori = this.$store.getters.getCentrosConsumo;
      return ori;
    },
    facturasDoc() {
      let data = [];
      this.productsDocument.forEach((prod) => {
        let itemIndex = this.$_.findIndex(data, { Id: prod.Factura.Id });
        if (itemIndex < 0) {
          data.push(prod.Factura);
        }
      });
      return data;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    if (this.$route.params.idDocumento) {
      this.title = "Edición de documento : " + this.$route.params.idDocumento;
      this.getDocumentInfo(this.$route.params.idDocumento);
    } else {
      this.Origen = this.origenes[0] ? this.origenes[0].id : "";
    }
    this.getProdDoc();
    //this.getOrigenes();
  },
};
</script>
